import React from 'react';
import './Badge.css';

/**
 * Modern Badge/Chip Component
 * 
 * @param {string} variant - 'default', 'primary', 'success', 'warning', 'critical', 'info'
 * @param {string} size - 'sm', 'md'
 * @param {boolean} outline - Outline style
 * @param {boolean} pill - Fully rounded
 */
const Badge = ({ 
  children, 
  variant = 'default', 
  size = 'md', 
  outline = false,
  pill = true,
  className = '',
  ...props 
}) => {
  const classes = [
    'ui-badge',
    `ui-badge--${variant}`,
    `ui-badge--${size}`,
    outline ? 'ui-badge--outline' : '',
    pill ? 'ui-badge--pill' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
};

export default Badge;
